import { isLHVMode } from '../src/app.mode';
import { AppPermission } from '../src/app.permission';

const routes = [
  {
    path: '/login',
    layout: false,
    component: './login',
  },
  {
    path: '/dynamic-report',
    layout: false,
    component: './dynamic-report/viewer',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    icon: 'dashboard',
    routes: [
      {
        name: 'workplace',
        path: '/dashboard/workplace',
        component: './dashboard/workplace',
        access: AppPermission.DashboardAll,
      },
      {
        name: 'tickets',
        path: '/dashboard/tickets',
        component: './dashboard/tickets',
        access: AppPermission.DashboardTickets,
      },
      {
        name: 'goods',
        path: '/dashboard/goods',
        component: './dashboard/goods',
        access: AppPermission.DashboardGoods,
      },
      {
        name: 'analytics',
        path: '/dashboard/analytics',
        component: './dashboard/analytics',
        access: AppPermission.DashboardAnalytics,
      },
      {
        name: 'monitor',
        path: '/dashboard/monitor',
        component: './dashboard/monitor',
        access: AppPermission.DashboardMonitor,
      },
      {
        name: 'yearly-report',
        path: '/dashboard/yearly-report',
        component: './dashboard/yearly-report',
        access: AppPermission.DashboardYearlyReport,
      },
      {
        name: 'company-yearly-report',
        path: '/dashboard/company-yearly-report',
        component: './dashboard/company-yearly-report',
        access: AppPermission.DashboardCompanyYearlyReport,
      },
    ],
  },
  {
    path: '/report',
    name: 'report',
    icon: 'read',
    routes: [
      {
        name: 'company-revenue',
        path: '/report/company-revenue',
        component: './report/company-revenue',
        access: AppPermission.ReportCompanyRevenue,
      },
      {
        name: 'company-charge-wallet',
        path: '/report/company-charge-wallet',
        component: './report/company-charge-wallet',
        access: AppPermission.ReportCompanyChargeWallet,
      },
      {
        name: 'company-payment-transaction',
        path: '/report/company-payment-transaction',
        component: './report/company-payment-transaction',
        access: AppPermission.CompanyPaymentTransactionView,
      },
    ],
  },
  {
    path: '/vietqr',
    name: 'vietqr',
    icon: 'bank',
    routes: [
      {
        path: '/vietqr/mbqr',
        name: 'mbqr',
        icon: 'bank',
        access: AppPermission.MBQRPaymentAll,
        routes: [
          {
            name: 'dashboard',
            path: '/vietqr/mbqr/dashboard',
            component: './mbqr/dashboard',
            access: AppPermission.MBQRPaymentDashboard,
          },
          {
            name: 'payments',
            path: '/vietqr/mbqr/payments',
            component: './mbqr/payments',
            access: AppPermission.MBQRPaymentReport,
          },
          {
            name: 'refunds',
            path: '/vietqr/mbqr/refund',
            component: './mbqr/refund',
            access: AppPermission.MBQRRefundView,
          },
          {
            name: 'terminals',
            path: '/vietqr/mbqr/terminals',
            component: './mbqr/terminals',
            access: AppPermission.MBQRTerminalView,
          },
          {
            redirect: '/vietqr/mbqr/payments',
          },
        ],
      },
      {
        path: '/vietqr/bidvqr',
        name: 'bidvqr',
        icon: 'bank',
        access: AppPermission.BIDVQRPaymentAll,
        routes: [
          {
            name: 'dashboard',
            path: '/vietqr/bidvqr/dashboard',
            component: './bidvqr/dashboard',
            access: AppPermission.BIDVQRPaymentDashboard,
          },
          {
            name: 'payments',
            path: '/vietqr/bidvqr/payments',
            component: './bidvqr/payments',
            access: AppPermission.BIDVQRPaymentReport,
          },
          // {
          //   name: 'refunds',
          //   path: '/bidvqr/refund',
          //   component: './bidvqr/refund',
          //   access: AppPermission.BIDVQRRefundView,
          // },
          {
            name: 'terminals',
            path: '/vietqr/bidvqr/terminals',
            component: './bidvqr/terminals',
            access: AppPermission.BIDVQRTerminalView,
          },
          {
            redirect: '/vietqr/bidvqr/payments',
          },
        ],
      },
      {
        path: '/vietqr/napas',
        name: 'napas',
        icon: 'bank',
        access: AppPermission.NapasQRPaymentAll,
        routes: [
          {
            name: 'dashboard',
            path: '/vietqr/napas/dashboard',
            component: './napas/dashboard',
            access: AppPermission.NapasQRPaymentDashboard,
          },
          {
            name: 'payments',
            path: '/vietqr/napas/payments',
            component: './napas/payments',
            access: AppPermission.NapasQRPaymentReport,
          },
          {
            name: 'terminals',
            path: '/vietqr/napas/terminals',
            component: './napas/terminals',
            access: AppPermission.NapasQRTerminalView,
          },
          {
            redirect: '/vietqr/napas/payments',
          },
        ],
      },
      {
        path: '/vietqr/vpb-qr',
        name: 'vpb-qr',
        icon: 'bank',
        access: AppPermission.VpbQRPaymentAll,
        routes: [
          {
            name: 'dashboard',
            path: '/vietqr/vpb-qr/dashboard',
            component: './vpb-qr/dashboard',
            access: AppPermission.VpbQRPaymentDashboard,
          },
          {
            name: 'payments',
            path: '/vietqr/vpb-qr/payments',
            component: './vpb-qr/payments',
            access: AppPermission.VpbQRPaymentReport,
          },
          {
            name: 'terminals',
            path: '/vietqr/vpb-qr/terminals',
            component: './vpb-qr/terminals',
            access: AppPermission.VpbQRTerminalView,
          },
          {
            name: 'vpbank-customer-sdk-log',
            path: '/vietqr/vpb-qr/vpbank-customer-sdk-log',
            component: './vpb-qr/vpbank-customer-sdk-log',
            access: AppPermission.VpbQRCustomerSdkLogView,
          },
          {
            redirect: '/vietqr/vpb-qr/payments',
          },
        ],
      },
      {
        path: '/vietqr/cloud-speaker',
        name: 'cloud-speaker',
        component: './cloud-speaker',
        access: AppPermission.CloudSpeakerView,
      },
    ],
  },
  {
    path: '/company',
    name: 'company',
    icon: 'shop',
    routes: [
      {
        path: '/company/list',
        name: 'list',
        component: './company',
        access: AppPermission.CompanyView,
      },
      {
        path: '/company/account',
        name: 'account',
        component: './company-account',
        access: AppPermission.CompanyAccountView,
      },
      {
        path: '/company/zalo-oa-account',
        name: 'zalo-oa-account',
        component: './company-zalooa-account',
        access: AppPermission.ZaloOaAccountView,
      },
      {
        path: '/company/brandname',
        name: 'brandname',
        component: './brandname',
        access: AppPermission.BrandnameView,
      },
      {
        path: '/company/invoice-config',
        name: 'invoice-config',
        component: './invoice-config',
        access: AppPermission.InvoiceConfigView,
      },
      {
        path: '/company/merchant-payment',
        name: 'merchant-payment',
        component: './merchant-payment',
        access: AppPermission.MerchantPaymentView,
      },
      {
        path: '/company/vehicle-utilities',
        name: 'vehicle-utilities',
        component: './vehicle-utilities',
        access: AppPermission.VehicleUtilitiesView,
      },
      {
        path: '/company/partner',
        name: 'company-partner',
        component: './company-partner',
        access: AppPermission.CompanyPartnerView,
      },
      {
        name: 'report',
        path: '/company/report',
        routes: [
          {
            name: 'balance-fluctuation',
            path: '/company/report/balance-fluctuation',
            component: './balance-fluctuation',
            access: AppPermission.BalanceFluctuationView,
          },
          {
            name: 'balance-fluctuation-missing',
            path: '/company/report/balance-fluctuation-missing',
            component: './balance-fluctuation-missing',
            access: AppPermission.BalanceFluctuationMissingView,
          },
          {
            name: 'data-sync',
            path: '/company/report/data-sync',
            component: './data-sync',
            access: AppPermission.DataSyncView,
          },
          {
            name: 'services',
            path: '/company/report/services',
            component: './company-services',
            access: AppPermission.CompanyView,
          },
          {
            name: 'services-used',
            path: '/company/report/services-used',
            component: './company-services-used',
            access: AppPermission.CompanyView,
          },
          {
            redirect: '/company/report/balance-fluctuation',
          },
        ],
      },
      {
        name: 'feedback',
        path: '/company/feedback',
        component: './company-feedback',
        access: AppPermission.CompanyFeedbackView,
      },
      {
        redirect: '/company/list',
      },
    ],
  },
  {
    path: '/partner',
    name: 'partner',
    icon: 'api',
    routes: [
      {
        path: '/partner/list',
        name: 'list',
        component: './company',
        access: AppPermission.PartnerView,
      },
      {
        path: '/partner/brandname',
        name: 'brandname',
        component: './brandname',
        access: AppPermission.BrandnameView,
      },
      {
        redirect: '/partner/list',
      },
    ],
  },
  {
    path: '/customer',
    name: 'customer',
    icon: 'user',
    routes: [
      {
        path: '/customer/lead',
        name: 'lead',
        component: './customer-lead',
        access: AppPermission.CustomerLeadView,
      },
      {
        path: '/customer/list',
        name: 'list',
        component: './customer',
        access: AppPermission.CustomerView,
      },
      {
        path: '/customer/care',
        name: 'care',
        component: './customer-care',
        access: AppPermission.CustomerView,
      },
      {
        path: '/customer/customer-status',
        name: 'customer-status',
        component: './customer-status',
        access: AppPermission.CustomerStatusView,
      },
      {
        redirect: '/customer/list',
      },
    ],
  },
  {
    path: '/partner-devices',
    name: 'partner-devices',
    icon: 'sound',
    routes: [
      {
        path: '/partner-devices/dashboard',
        name: 'dashboard',
        component: './partner-devices/dashboard',
        access: AppPermission.LHVPartnerView,
      },
      {
        path: '/partner-devices/lhv-partner',
        name: 'lhv-partner',
        component: './partner-devices/lhv-partner',
        access: AppPermission.LHVPartnerView,
      },
      {
        redirect: '/partner-devices/dashboard',
      },
    ],
  },
  {
    path: '/transit-with-partner',
    name: 'transit-with-partner',
    icon: 'car',
    routes: [
      {
        name: 'dashboard',
        path: '/transit-with-partner/dashboard',
        component: './transit-with-partner/dashboard',
        access: AppPermission.TransitWithPartnerDashboard,
        customRightContent: {
          notification: 'transit-notification',
        },
      },
      {
        name: 'coordination',
        path: '/transit-with-partner/coordination',
        component: './transit-with-partner/coordination',
        access: AppPermission.TransitWithPartnerView,
        customRightContent: {
          notification: 'transit-notification',
        },
      },
      {
        name: 'coordination2',
        path: '/transit-with-partner/coordination2',
        component: './transit-with-partner/coordination2',
        access: AppPermission.TransitWithPartnerView,
        customRightContent: {
          notification: 'transit-notification',
        },
      },
      {
        name: 'coordination-history',
        path: '/transit-with-partner/coordination-history',
        component: './transit-with-partner/coordination-history',
        access: AppPermission.TransitWithPartnerView,
        customRightContent: {
          notification: 'transit-notification',
        },
      },
      {
        name: 'anvui-stop-point',
        path: '/transit-with-partner/anvui-stop-point',
        component: './transit-anvui-stop-point',
        access: AppPermission.TransitAnvuiStopPointView,
        customRightContent: {
          notification: 'transit-notification',
        },
      },
      {
        name: 'transit-config',
        path: '/transit-with-partner/config',
        component: './transit-config',
        access: AppPermission.TransitAnvuiStopPointConfigFee,
      },
      {
        name: 'report',
        path: '/transit-with-partner/report',
        routes: [
          {
            name: 'transit-ticket',
            path: '/transit-with-partner/report/transit-ticket',
            component: './transit-report/transit-ticket',
            access: AppPermission.TransitAnvuiReportTicketView,
          },
          {
            name: 'staff-revenue',
            path: '/transit-with-partner/report/staff-revenue',
            component: './transit-report/staff-revenue',
            access: AppPermission.TransitAnvuiReportStaffRevenueView,
          },
          {
            name: 'company-revenue',
            path: '/transit-with-partner/report/company-revenue',
            component: './transit-report/company-revenue',
            access: AppPermission.TransitAnvuiReportCompanyRevenueView,
          },
          {
            redirect: '/transit-with-partner/report/transit-ticket',
          },
        ],
      },
      {
        name: 'station-report',
        path: '/transit-with-partner/station-report',
        routes: [
          {
            name: 'tickets',
            path: '/transit-with-partner/station-report/tickets',
            component: './transit-report-station/tickets',
            access: AppPermission.TransitAnvuiReportStationTicketView,
          },
          {
            name: 'company-revenue',
            path: '/transit-with-partner/station-report/company-revenue',
            component: './transit-report-station/company-revenue',
            access: AppPermission.TransitAnvuiReportStationRevenueView,
          },
          {
            redirect: '/transit-with-partner/station-report/tickets',
          },
        ],
      },
      {
        name: 'surcharge-rules',
        path: '/transit-with-partner/surcharge-rules',
        component: './transit-surcharge-rules',
        access: AppPermission.TransitSurchargeRuleView,
      },
      {
        name: 'transit-dispatch-display-config',
        path: '/transit-with-partner/dispatch-display-config',
        component: './transit-dispatch-display-config',
        access: AppPermission.TransitWithPartnerView,
      },
      {
        redirect: '/transit-with-partner/dashboard',
      },
    ],
  },
  {
    path: '/landing',
    name: 'landing',
    icon: 'chrome',
    routes: [
      {
        name: 'news',
        path: '/landing/news',
        component: './config-web',
        access: AppPermission.ConfigWebUpdate,
      },
      {
        name: 'recruit',
        path: '/landing/recruit',
        component: './config-recruit',
        access: AppPermission.ConfigWebRecruit,
      },
    ],
  },
  {
    path: '/admin',
    name: 'admin',
    icon: 'crown',
    routes: [
      {
        name: 'promotion',
        path: '/admin/promotion',
        component: './payment-package',
        access: AppPermission.PaymentPackageView,
      },
      {
        name: 'system-banner',
        path: '/admin/system-banner',
        component: './system-banner',
        access: AppPermission.SystemBannerView,
      },
      {
        name: 'menu',
        path: '/admin/menu',
        component: './menu',
        access: AppPermission.MenuPackageView,
      },
      {
        name: 'user',
        path: '/admin/user',
        component: './user',
        access: AppPermission.UserView,
      },
      {
        name: 'client',
        path: '/admin/client',
        component: './client',
        access: AppPermission.ClientView,
      },
      {
        name: 'permission',
        path: '/admin/permission',
        component: './permission',
        access: AppPermission.PermissionView,
      },
      {
        name: 'dynamic-report-editor',
        path: '/admin/dynamic-report',
        component: './dynamic-report/editor',
        access: AppPermission.DynamicReportAll,
      },
      {
        name: 'company-notification',
        path: '/admin/company-notification',
        component: './company-notification',
        access: AppPermission.CompanyNotificationView,
      },
      {
        redirect: '/admin/user',
      },
    ],
  },
  {
    path: '/account',
    name: 'account',
    component: './account',
    hideInMenu: true,
  },
  {
    path: '/',
    redirect: '/dashboard/workplace',
  },
  {
    path: '*',
    component: './404',
  },
];

// Chế độ LHV admin: chỉ giữ nhóm /partner-devices, trang chủ trỏ về dashboard thiết bị
const lhvRoutes = [
  routes.find((route) => route.path === '/partner-devices')!,
  {
    path: '/',
    redirect: '/partner-devices/dashboard',
  },
  {
    path: '*',
    component: './404',
  },
];

export default isLHVMode ? lhvRoutes : routes;
